import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { H2 } from "../../components/headline/Headline";
import EventFaq from "./faq/EventFaq";

export default function Events() {

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return <>
        <H2 text='Events buchen' />
        <Outlet />
        <EventFaq />
    </>
}